import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import * as fromAuth from '@auth/reducers';
import * as AuthActions from '@auth/actions/auth';

@Injectable()
export class InterceptService implements HttpInterceptor {

  constructor(
    private router: Router,
    private store: Store<fromAuth.State>,
    private translateService: TranslateService,
    private snackBar: MatSnackBar,
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.isAtLoginPage()) {
      return next.handle(request);
    }

    const token = localStorage.getItem('token');
    const currentLocale = localStorage.getItem('v6_language') || 'en';
    const modifiedRequest = request.clone({
      setHeaders: {
        token,
        currentLocale  // temp regulation
      }
    });

    return next.handle(modifiedRequest).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            // console.log(event.status);
            // console.log('event body', event.body);
          }
        },
        error => {
          this.errorHandler(error);
        },
      )
    );
  }

  private errorHandler(error) {
    // console.error(error.status);
    // console.error('error message', error.message);
    let msg: string;
    switch (error.status) {
      case 401:
        msg = this.translateService.instant('HTTP_ERROR_MSG.401');
        if (!this.isAtLoginPage()) {
          sessionStorage.setItem('savedUrl', this.router.url);
        }
        this.clearAuthState();
        break;
      case 404:
        msg = this.translateService.instant('HTTP_ERROR_MSG.404');
        if (!this.isAtLoginPage()) {
          sessionStorage.setItem('savedUrl', this.router.url);
        }
        this.clearAuthState();
        break;
      case 413:
        msg = this.translateService.instant('HTTP_ERROR_MSG.413');
        break;
      default:
        msg = error.message;
        break;
    }
    if (msg) {
      this.snackBar.open(msg, '', { duration: 5000 });
    }
  }

  private isAtLoginPage(): boolean {
    return this.router.url === '/auth/login';
  }

  private clearAuthState() {
    this.store.dispatch(AuthActions.Logout());
  }
}
